import lodash from 'lodash'
import * as React from 'react'

import {getDateFormat} from '@base/app-services/i18n-format'
import {autobind} from '@base/decorators'
import {themeable, classNames, pickProps, omitProps} from '@base/react-utils'

import SemiControlledInput from '../SemiControlledInput'
import TextInput from '../TextInput'
import {textInputClassName} from '../TextInputLayout'
import CalendarSelect from './CalendarSelect'
import CalendarSelectController from './CalendarSelectController'
import * as helpers from './helpers'

// eslint-disable-next-line react/no-unsafe
class DateInput extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      filter: null,
    }
  }

  UNSAFE_componentWillMount() {
    this.updateStateWithProps(this.props)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateStateWithProps(nextProps)
  }

  updateStateWithProps(props) {
    const item = lodash.get(props, 'item')

    if (item !== this.state.item) {
      this.setState({item, filter: null})
      return
    }

    const filter = lodash.get(props, ['value', 'filter'], null)

    if (filter !== this.state.filter) {
      this.setState({filter})
    }
  }

  getValue(defaultValue = null) {
    if (this.state.filter) {
      return this.state.filter
    }
    if (this.props.item) {
      return this.props.item
    }
    return defaultValue
  }

  @autobind
  handleValueChange(value) {
    this.props.onValueChange({
      filter: value || null,
      mode: 'exact',
    })
  }

  @autobind
  handleClick(event) {
    const {onClick} = this.props
    if (onClick) {
      onClick(event)
    }
  }

  @autobind
  handleKeyDown(event) {
    const {onKeyDown} = this.props
    if (onKeyDown) {
      onKeyDown(event)
    }
  }

  @autobind
  handleFocus(event) {
    const {onFocus} = this.props
    if (onFocus) {
      onFocus(event)
    }
  }

  @autobind
  handleBlur(event) {
    const {onBlur} = this.props
    if (onBlur) {
      onBlur(event)
    }
  }

  render() {
    const value = this.getValue()
    const {focused, hovered, hidePlaceholder, append} = this.props
    return (
      <TextInput
        theme={this.theme}
        width="max"
        value={value}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        onValueChange={this.handleValueChange}
        placeholder={!hidePlaceholder ? getDateFormat() : undefined}
        focused={focused}
        CustomInputComponent={SemiControlledInput}
        className={classNames(
          this.props.className,
          textInputClassName(this.props)
        )}
        tabIndex={this.props.tabIndex}
        hovered={hovered}
        append={append}
      />
    )
  }
}

@themeable()
class InputDateSelect extends React.PureComponent {
  static defaultProps = {
    openOnMount: true,
    closeOnValueChange: false,
  }

  renderSelect() {
    return (
      <CalendarSelect
        datePresets={this.props.datePresets}
        daysOutside={false}
        tabIndex={-1}
      />
    )
  }

  @autobind
  isUnivocalFilter(filter) {
    // filter is univocal - matches single value explicitly
    // when it is either cleared or is a valid date

    const filterValue = lodash.get(filter, 'filter', null)
    if (!filterValue) {
      return true
    }
    if (helpers.parseDate(filterValue)) {
      return true
    }
    return false
  }

  @autobind
  getUnivocalFilterMatch(filter, value) {
    return lodash.get(filter, 'filter') || null
  }

  @autobind
  getInitialFilter() {
    return {
      mode: 'exact',
      filter: null,
    }
  }

  render() {
    const {width} = this.props
    return (
      <CalendarSelectController
        {...omitProps(this.props, [
          'feedback',
          'append',
          'prepend',
          'timeFormat',
        ])}
        closeOutOfView="any"
        targetContainer="auto"
        showFilteringInput="never"
        initialFilter={this.getInitialFilter()}
        isUnivocalFilter={this.isUnivocalFilter}
        getUnivocalFilterMatch={this.getUnivocalFilterMatch}
        select={this.renderSelect()}
        isItemEqual={lodash.isEqual}
        allowShift="100%"
        width={width || 'fill'}
      >
        <DateInput
          {...pickProps(this.props, [
            'feedback',
            'append',
            'prepend',
            'width',
            'height',
            'tabIndex',
            'focused',
            'hovered',
            'hidePlaceholder',
            'className',
          ])}
        />
      </CalendarSelectController>
    )
  }
}

export default InputDateSelect
